/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_Withdraw_DescInputs */

const en_privacy_section_7_withdraw_desc = /** @type {(inputs: Privacy_Section_7_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`withdraw your consent at any time where processing is based on consent`)
};

const lv_privacy_section_7_withdraw_desc = /** @type {(inputs: Privacy_Section_7_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atsaukt savu piekrišanu jebkurā laikā, ja apstrāde balstās uz piekrišanu`)
};

/**
* | output |
* | --- |
* | "withdraw your consent at any time where processing is based on consent" |
*
* @param {Privacy_Section_7_Withdraw_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_withdraw_desc = /** @type {((inputs?: Privacy_Section_7_Withdraw_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_Withdraw_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_withdraw_desc(inputs)
	return en_privacy_section_7_withdraw_desc(inputs)
});